import VerifyAccountDetail from "./VerifyAccountDetail";
import VerifyAccountSecurity from "./VerifyAccountSecurity";
import React from "react";
import VerifyCommunityDetail from "./VerifyCommunityDetail";
import SpotLiveTradeSettings from "../../sharedPages/newSetting/SpotLiveTradeSettings/SpotLiveTradeSettings";

const VerifyTradeSettings = () => {

  return (
    <>
      <div className="AccountSettingPage">
      <VerifyCommunityDetail />
        <VerifyAccountDetail />
        <VerifyAccountSecurity />
        <SpotLiveTradeSettings />
      </div>
    </>
  );
};

export default VerifyTradeSettings;
